export default "__VITE_ASSET__ba144ffb__"